(function () {
  var approvedQuantities = ['50', '100', '150', '200', '250', '300', '400', '500'];
  var discountPercent = { 50: 0, 100: 15, 150: 20, 200: 25, 250: 30, 300: 33, 400: 36, 500: 40 };
  var pricing = {
    '#1 \u2013 4-Page Standard Obituary': { 50: 100, 100: 170, 150: 240, 200: 300, 250: 350, 300: 402, 400: 512, 500: 600 },
    '#2 \u2013 8-Page Standard Obituary': { 50: 125, 100: 212.5, 150: 300, 200: 375, 250: 437.5, 300: 502.5, 400: 640, 500: 750 },
    '#3 \u2013 12-Page Standard Obituary': { 50: 150, 100: 255, 150: 360, 200: 450, 250: 525, 300: 603, 400: 768, 500: 900 },
    '#4 Standard 4 Page Bi-Fold (7x8.5)': { 50: 150, 100: 255, 150: 360, 200: 450, 250: 525, 300: 603, 400: 768, 500: 900 },
    '#5 Standard 8 Page Bi-Fold (7x8.5)': { 50: 200, 100: 340, 150: 480, 200: 600, 250: 700, 300: 804, 400: 1024, 500: 1200 },
    '#6 Legal Tri-Fold': { 50: 150, 100: 255, 150: 360, 200: 450, 250: 525, 300: 603, 400: 768, 500: 900 },
    '#7 Big Tri-Fold': { 50: 175, 100: 297.5, 150: 420, 200: 525, 250: 612.5, 300: 703.5, 400: 896, 500: 1050 },
    '#8 Honorable Tri-Fold': { 50: 175, 100: 297.5, 150: 420, 200: 525, 250: 612.5, 300: 703.5, 400: 896, 500: 1050 },
    '#9 4 Page Big Book': { 50: 175, 100: 297.5, 150: 420, 200: 525, 250: 612.5, 300: 703.5, 400: 896, 500: 1050 },
    '#10 8 Page Big Book': { 50: 250, 100: 425, 150: 600, 200: 750, 250: 875, 300: 1005, 400: 1280, 500: 1500 },
    '#11 12 Page Big Book': { 50: 325, 100: 552.5, 150: 780, 200: 975, 250: 1137.5, 300: 1306.5, 400: 1664, 500: 1950 },
    '#12 16 Page Big Book': { 50: 400, 100: 680, 150: 960, 200: 1200, 250: 1400, 300: 1608, 400: 2048, 500: 2400 },
    '#13 20 Page Big Book': { 50: 475, 100: 807.5, 150: 1140, 200: 1425, 250: 1662.5, 300: 1909.5, 400: 2432, 500: 2850 }
  };
  var scheduled = false;

  function formatMoney(value) {
    return '$' + value.toLocaleString('en-US', {
      minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
      maximumFractionDigits: 2
    });
  }

  function formatUnitMoney(value) {
    return '$' + value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function ensureStyles() {
    if (document.getElementById('memorial-value-styles')) return;
    var style = document.createElement('style');
    style.id = 'memorial-value-styles';
    style.textContent = [
      '.memorial-value-display{margin-top:8px;padding:10px 12px;border-left:4px solid #000;background:var(--color-header-text,#ffcb05);color:#000;font-size:.92rem;line-height:1.45;border-radius:2px}',
      '.memorial-value-display p{margin:0;color:#000}',
      '.memorial-value-display .memorial-value-unit{font-weight:700}',
      '.memorial-value-display .memorial-value-savings{color:#000}',
      '.memorial-value-display .memorial-value-popular{margin-top:4px;font-weight:800;color:#000}',
      '@media (max-width:749px){.memorial-value-display{font-size:.88rem;padding:9px 10px}}'
    ].join('');
    document.head.appendChild(style);
  }

  function getDisplay(form) {
    var existing = form.querySelector('.memorial-value-display');
    if (existing) return existing;
    var priceText = form.querySelector('.element-text--price');
    var priceBlock = priceText && priceText.closest('.shopify-block');
    if (!priceBlock) return null;
    var display = document.createElement('div');
    display.className = 'memorial-value-display';
    display.setAttribute('aria-live', 'polite');
    display.hidden = true;
    priceBlock.insertAdjacentElement('afterend', display);
    return display;
  }

  // The baseline comes from the active 50-copy Shopify variant for the selected program.
  // Quantities 100-500 display the exact approved discount ladder, capped at 40%.
  function savingsMarkup(program, quantity) {
    var selectedPrice = pricing[program][quantity];
    var baselineUnit = pricing[program][50] / 50;
    var selectedUnit = selectedPrice / quantity;
    var markup = '<p class="memorial-value-unit">Only ' + formatUnitMoney(selectedUnit) + ' per memorial program</p>';
    if (quantity === 50) return markup + '<p>Larger quantities lower your cost per program.</p>';
    var dollarSavings = (baselineUnit * quantity) - selectedPrice;
    markup += '<p class="memorial-value-savings">You save ' + formatMoney(dollarSavings) + ' by ordering ' + quantity + '</p>' +
      '<p class="memorial-value-savings">Save ' + discountPercent[quantity] + '% per program</p>';
    if (quantity === 200) markup += '<p class="memorial-value-popular">Most Popular Quantity</p>';
    return markup;
  }

  function getMainPrice(form) {
    var price = form.querySelector('.element-text--price');
    if (!price) return null;
    var dollars = price.querySelector('span');
    var cents = price.querySelector('sup');
    if (!dollars) return null;
    var whole = Number(dollars.textContent.replace(/[^0-9]/g, ''));
    var fractional = cents ? Number(cents.textContent.replace(/[^0-9]/g, '')) / 100 : 0;
    return Number.isFinite(whole + fractional) ? whole + fractional : null;
  }

  // Reorder the existing option controls in the DOM; Shopify variants remain the source of cart and checkout prices.
  function orderQuantityLabels(form) {
    var labels = {};
    var parent = null;
    form.querySelectorAll('input[name="Quantity"]').forEach(function (input) {
      var label = input.closest('label.element-radio');
      if (!label) return;
      labels[input.value] = label;
      if (!parent) parent = label.parentElement;
    });
    if (!parent) return;
    var currentOrder = Array.prototype.filter.call(parent.children, function (child) {
      var input = child.querySelector && child.querySelector('input[name="Quantity"]');
      return input && approvedQuantities.indexOf(input.value) !== -1;
    }).map(function (child) {
      return child.querySelector('input[name="Quantity"]').value;
    });
    if (currentOrder.join('|') === approvedQuantities.join('|')) return;
    approvedQuantities.forEach(function (quantity) {
      if (labels[quantity] && labels[quantity].parentElement === parent) parent.appendChild(labels[quantity]);
    });
  }

  function applyRules() {
    scheduled = false;
    ensureStyles();
    document.querySelectorAll('form.shopify-product-form').forEach(function (form) {
      var programs = form.querySelectorAll('input[name="Type of Program"]');
      if (!programs.length) return;
      var selectedProgram = form.querySelector('input[name="Type of Program"]:checked');
      if (!selectedProgram || !Object.prototype.hasOwnProperty.call(pricing, selectedProgram.value)) return;
      var program = selectedProgram.value;
      var selectedQuantity = form.querySelector('input[name="Quantity"]:checked');

      form.querySelectorAll('input[name="Quantity"]').forEach(function (input) {
        var visible = approvedQuantities.indexOf(input.value) !== -1;
        var label = input.closest('label.element-radio');
        input.disabled = !visible;
        if (label) {
          label.style.display = visible ? '' : 'none';
          label.setAttribute('aria-hidden', String(!visible));
        }
      });
      orderQuantityLabels(form);

      if (!selectedQuantity || approvedQuantities.indexOf(selectedQuantity.value) === -1) {
        var fallback = form.querySelector('input[name="Quantity"][value="50"]');
        if (fallback) {
          fallback.disabled = false;
          fallback.click();
          selectedQuantity = fallback;
        }
      }

      var display = getDisplay(form);
      if (!display || !selectedQuantity || !pricing[program][selectedQuantity.value]) {
        if (display) display.hidden = true;
        return;
      }
      var approvedPrice = pricing[program][selectedQuantity.value];
      var livePrice = getMainPrice(form);
      if (livePrice === null || Math.abs(livePrice - approvedPrice) > 0.009) {
        display.hidden = true;
        return;
      }
      var markup = savingsMarkup(program, Number(selectedQuantity.value));
      if (display.innerHTML !== markup) display.innerHTML = markup;
      display.hidden = false;
    });
  }

  function scheduleRules() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(applyRules);
  }

  // Program and quantity changes both recalculate from the same selections used by Shopify pricing.
  document.addEventListener('change', function (event) {
    if (event.target.matches('input[name="Type of Program"], input[name="Quantity"]')) scheduleRules();
  });
  new MutationObserver(scheduleRules).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleRules, { once: true });
  else scheduleRules();
})();

;(function () {
  if (!/^\/products\//.test(window.location.pathname)) return;

  function formatMoney(value) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
  }

  function variantTier(variant) {
    var label = String(variant.option1 || variant.title || '');
    var match = label.match(/(\d[\d,]*)\s*pieces?/i);
    if (!match) return null;
    return {
      quantity: Number(match[1].replace(/,/g, '')),
      method: label.slice(0, match.index).replace(/[—–-]\s*$/, '').trim() || 'Standard',
      extras: (variant.options || []).slice(1).join('|')
    };
  }

  function installLionCircleValueDisplay(product) {
    if (!product || product.vendor !== 'Lion Circle') return;
    var form = document.querySelector('form[action*="/cart/add"]');
    var priceBlock = document.querySelector('.product-pricing');
    if (!form || !priceBlock || !Array.isArray(product.variants)) return;

    if (!document.getElementById('lion-circle-value-styles')) {
      var style = document.createElement('style');
      style.id = 'lion-circle-value-styles';
      style.textContent = '.lion-circle-value-display{margin-top:8px;padding:10px 12px;border-left:4px solid #000;background:#ffcb05;color:#000;font-size:.92rem;line-height:1.45}.lion-circle-value-display p{margin:0;color:#000}.lion-circle-value-display .lion-circle-value-unit{font-weight:700}@media (max-width:749px){.lion-circle-value-display{font-size:.88rem;padding:9px 10px}}';
      document.head.appendChild(style);
    }

    var display = document.querySelector('.lion-circle-value-display');
    if (!display) {
      display = document.createElement('div');
      display.className = 'lion-circle-value-display';
      display.setAttribute('aria-live', 'polite');
      priceBlock.insertAdjacentElement('afterend', display);
    }

    var lastVariantId = '';
    function update() {
      var idField = form.querySelector('[name="id"]');
      var variantId = idField ? String(idField.value) : '';
      var variant = product.variants.find(function (item) { return String(item.id) === variantId; }) || product.variants[0];
      var selected = variant && variantTier(variant);
      if (!variant || !selected || !selected.quantity) {
        display.hidden = true;
        return;
      }

      var comparable = product.variants.map(function (item) {
        return { variant: item, tier: variantTier(item) };
      }).filter(function (item) {
        return item.tier && item.tier.method === selected.method && item.tier.extras === selected.extras;
      }).sort(function (a, b) { return a.tier.quantity - b.tier.quantity; });
      var baseline = comparable[0];
      if (!baseline) {
        display.hidden = true;
        return;
      }

      var selectedPrice = Number(variant.price) / 100;
      var selectedUnit = selectedPrice / selected.quantity;
      var baselineUnit = (Number(baseline.variant.price) / 100) / baseline.tier.quantity;
      var markup = '<p class="lion-circle-value-unit">Only ' + formatMoney(selectedUnit) + ' per fan</p>';
      if (selected.quantity === baseline.tier.quantity) {
        markup += '<p>Larger quantities lower your cost per fan.</p>';
      } else {
        var dollarSavings = Math.max(0, (baselineUnit * selected.quantity) - selectedPrice);
        var percentSavings = Math.max(0, Math.round((1 - (selectedUnit / baselineUnit)) * 100));
        markup += '<p>You save ' + formatMoney(dollarSavings) + ' by ordering ' + selected.quantity.toLocaleString('en-US') + '</p>';
        markup += '<p>Save ' + percentSavings + '% per fan</p>';
      }
      display.innerHTML = markup;
      display.hidden = false;
      lastVariantId = String(variant.id);
    }

    document.addEventListener('change', function () { window.setTimeout(update, 0); });
    window.setInterval(function () {
      var idField = form.querySelector('[name="id"]');
      if (idField && String(idField.value) !== lastVariantId) update();
    }, 400);
    update();
  }

  fetch(window.location.pathname.replace(/\/$/, '') + '.js')
    .then(function (response) { return response.ok ? response.json() : null; })
    .then(installLionCircleValueDisplay)
    .catch(function () {});
})();